import { takeEvery } from 'redux-saga/effects';
import * as actionTypes from '../redux/actionTypes';
import { submitQSASaga } from '../sagas/submitRSPSaga';
import { confirmQSASaga } from '../sagas/confirmRSPSaga';

export function* requestForSearchPaymentSaga() {
  yield takeEvery(actionTypes.SUBMIT, submitQSASaga);
  yield takeEvery(actionTypes.CONFIRM, confirmQSASaga);
}
